import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../App';
import { Dialog, DialogContent } from './ui/dialog';
import { Button } from './ui/button';
import axios from 'axios';
import { toast } from 'sonner';

const CATEGORIAS = [
  { value: 'login', label: 'Acceso / Login', icon: 'fa-key', color: 'text-blue-500' },
  { value: 'pruebas', label: 'Pruebas y Examenes', icon: 'fa-file-alt', color: 'text-purple-500' },
  { value: 'chat', label: 'Chat / Mensajes', icon: 'fa-comments', color: 'text-green-500' },
  { value: 'pagos', label: 'Pagos / Cuotas', icon: 'fa-credit-card', color: 'text-amber-500' },
  { value: 'clases', label: 'Clases / Material', icon: 'fa-book', color: 'text-indigo-500' },
  { value: 'otro', label: 'Otro', icon: 'fa-question-circle', color: 'text-gray-500' }
];

const PRIORIDADES = [
  { value: 'baja', label: 'Baja', color: 'bg-gray-100 text-gray-600' },
  { value: 'normal', label: 'Normal', color: 'bg-blue-100 text-blue-600' },
  { value: 'urgente', label: 'Urgente', color: 'bg-red-100 text-red-600' }
];

const DAY_MAP = { 0: 'dom', 1: 'lun', 2: 'mar', 3: 'mie', 4: 'jue', 5: 'vie', 6: 'sab' };

const SoporteButton = () => {
  const { API } = useContext(AuthContext);
  const [isOpen, setIsOpen] = useState(false);
  const [view, setView] = useState('menu');
  const [categoria, setCategoria] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [prioridad, setPrioridad] = useState('normal');
  const [loading, setLoading] = useState(false);
  const [videoUrl, setVideoUrl] = useState('');
  const [adminDisponible, setAdminDisponible] = useState(false);
  const [horarioTexto, setHorarioTexto] = useState('');
  const [citaFecha, setCitaFecha] = useState('');
  const [citaHora, setCitaHora] = useState('');
  const [citaMotivo, setCitaMotivo] = useState('');
  const [horasDisponibles, setHorasDisponibles] = useState([]);
  const [scheduleData, setScheduleData] = useState(null);
  const [misCitas, setMisCitas] = useState([]);
  const [controlRemotoPendiente, setControlRemotoPendiente] = useState(null); // {admin_nombre, ticket_id, creado_en}
  const [showTeamViewerModal, setShowTeamViewerModal] = useState(false);

  // Detectar SO para sugerir el descargable correcto
  const detectarSO = () => {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.includes('mac')) return 'mac';
    if (ua.includes('linux')) return 'linux';
    if (ua.includes('android')) return 'android';
    if (ua.includes('iphone') || ua.includes('ipad')) return 'ios';
    return 'windows';
  };

  useEffect(() => {
    checkAdminDisponible();
    fetchControlRemotoPendiente();
    const interval = setInterval(checkAdminDisponible, 60000);
    const intervalCR = setInterval(fetchControlRemotoPendiente, 120000); // chequea cada 2 min
    return () => { clearInterval(interval); clearInterval(intervalCR); };
  }, []);

  const fetchControlRemotoPendiente = async () => {
    try {
      const response = await axios.get(`${API}/soporte/tickets`);
      const tickets = Array.isArray(response.data) ? response.data : [];
      // Buscar el ticket más reciente con control_remoto_solicitado, no resuelto
      const conControl = tickets
        .filter(t => t.control_remoto_solicitado && !['resuelto', 'cerrado'].includes(t.estado))
        .sort((a, b) => new Date(b.control_remoto_creado_en || 0) - new Date(a.control_remoto_creado_en || 0))[0];
      if (conControl) {
        const minutosTranscurridos = conControl.control_remoto_creado_en
          ? (Date.now() - new Date(conControl.control_remoto_creado_en).getTime()) / 60000
          : 999;
        if (minutosTranscurridos < 60) {
          setControlRemotoPendiente({
            admin_nombre: conControl.control_remoto_admin_nombre || 'el administrador',
            ticket_id: conControl.id,
            creado_en: conControl.control_remoto_creado_en,
          });
          return;
        }
      }
      setControlRemotoPendiente(null);
    } catch (e) {
      // silencio
    }
  };

  const fetchMisCitas = async () => {
    try {
      const response = await axios.get(`${API}/soporte/tickets`);
      const todas = Array.isArray(response.data) ? response.data : [];
      const ahora = new Date();
      const activas = todas
        .filter(t => {
          if (!t.es_cita || !t.sala_url) return false;
          // Excluir cualquier estado terminal (cerrado, resuelto, cancelado)
          const estadosFinal = ['cerrado', 'resuelto', 'cancelado'];
          if (estadosFinal.includes(t.estado)) return false;
          // Excluir citas cuya fecha ya pasó hace más de 2 horas (cortesía: mostramos las "en curso")
          if (t.cita_fecha && t.cita_hora) {
            try {
              const fechaCita = new Date(`${t.cita_fecha}T${t.cita_hora}:00`);
              const dosHorasDespues = new Date(fechaCita.getTime() + 2 * 60 * 60 * 1000);
              if (ahora > dosHorasDespues) return false;
            } catch (_e) { /* fecha malformada: no filtrar por fecha */ }
          }
          return true;
        })
        .sort((a, b) => {
          const da = `${a.cita_fecha || ''} ${a.cita_hora || ''}`;
          const db_ = `${b.cita_fecha || ''} ${b.cita_hora || ''}`;
          return da.localeCompare(db_);
        });
      setMisCitas(activas);
    } catch (e) {
      setMisCitas([]);
    }
  };

  const checkAdminDisponible = async () => {
    try {
      const response = await axios.get(`${API}/stream-chat/schedule/ibauruguay01@gmail.com`);
      const schedule = response.data;
      if (!schedule || !schedule.days) {
        setAdminDisponible(false);
        setHorarioTexto('Sin horario definido');
        setScheduleData(null);
        return;
      }
      setScheduleData(schedule);

      const now = new Date();
      const dayKey = DAY_MAP[now.getDay()];
      const daySchedule = schedule.days[dayKey];

      if (!daySchedule || !daySchedule.enabled) {
        setAdminDisponible(false);
        const proximoDia = getProximoDiaDisponible(schedule.days, now.getDay());
        setHorarioTexto(proximoDia ? `Disponible: ${proximoDia}` : 'No disponible hoy');
        return;
      }

      const currentMinutes = now.getHours() * 60 + now.getMinutes();
      const [fromH, fromM] = daySchedule.from.split(':').map(Number);
      const [toH, toM] = daySchedule.to.split(':').map(Number);
      const fromMinutes = fromH * 60 + fromM;
      const toMinutes = toH * 60 + toM;

      if (currentMinutes >= fromMinutes && currentMinutes <= toMinutes) {
        setAdminDisponible(true);
        setHorarioTexto(`Disponible hasta ${daySchedule.to}hs`);
      } else {
        setAdminDisponible(false);
        if (currentMinutes < fromMinutes) {
          setHorarioTexto(`Disponible desde ${daySchedule.from}hs`);
        } else {
          const proximoDia = getProximoDiaDisponible(schedule.days, now.getDay());
          setHorarioTexto(proximoDia || 'Fuera de horario');
        }
      }
    } catch {
      setAdminDisponible(false);
      setHorarioTexto('');
    }
  };

  const getProximoDiaDisponible = (days, currentDay) => {
    const nombres = { lun: 'Lunes', mar: 'Martes', mie: 'Miercoles', jue: 'Jueves', vie: 'Viernes', sab: 'Sabado', dom: 'Domingo' };
    const orden = ['lun', 'mar', 'mie', 'jue', 'vie', 'sab', 'dom'];
    const dayKeys = Object.values(DAY_MAP);
    for (let i = 1; i <= 7; i++) {
      const nextDay = (currentDay + i) % 7;
      const key = dayKeys[nextDay];
      if (days[key] && days[key].enabled) {
        return `${nombres[key]} ${days[key].from}-${days[key].to}hs`;
      }
    }
    return null;
  };

  const resetForm = () => {
    setView('menu');
    setCategoria('');
    setDescripcion('');
    setPrioridad('normal');
    setVideoUrl('');
    setCitaFecha('');
    setCitaHora('');
    setCitaMotivo('');
    setHorasDisponibles([]);
  };

  const handleFechaChange = (fecha) => {
    setCitaFecha(fecha);
    setCitaHora('');
    if (!scheduleData || !scheduleData.days) return;
    
    const dateObj = new Date(fecha + 'T12:00:00');
    const dayKey = DAY_MAP[dateObj.getDay()];
    const daySchedule = scheduleData.days[dayKey];
    
    if (!daySchedule || !daySchedule.enabled) {
      setHorasDisponibles([]);
      return;
    }
    
    const [fromH] = daySchedule.from.split(':').map(Number);
    const [toH] = daySchedule.to.split(':').map(Number);
    const horas = [];
    for (let h = fromH; h < toH; h++) {
      horas.push(`${String(h).padStart(2, '0')}:00`);
      horas.push(`${String(h).padStart(2, '0')}:30`);
    }
    setHorasDisponibles(horas);
  };

  const handleCrearCita = async () => {
    if (!citaFecha || !citaHora || !citaMotivo.trim()) {
      toast.error('Completa fecha, hora y motivo');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/soporte/citas`, {
        fecha: citaFecha,
        hora: citaHora,
        motivo: citaMotivo
      });
      toast.success('Cita agendada. Recibiras una notificacion de recordatorio.');
      fetchMisCitas();
      setIsOpen(false);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al crear cita');
    } finally {
      setLoading(false);
    }
  };

  const handleOpen = () => {
    resetForm();
    checkAdminDisponible();
    fetchMisCitas();
    setIsOpen(true);
  };

  const handleEnviarTicket = async () => {
    if (!categoria || !descripcion.trim()) {
      toast.error('Completa la categoria y descripcion');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/soporte/tickets`, { categoria, descripcion, prioridad });
      toast.success('Ticket enviado. El administrador sera notificado.');
      setIsOpen(false);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al enviar ticket');
    } finally {
      setLoading(false);
    }
  };

  const handleIniciarVideo = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${API}/soporte/videollamada`);
      setVideoUrl(response.data.sala_url);
      setView('video');
      toast.success('Sala creada. El administrador fue notificado.');
    } catch (error) {
      toast.error('Error al crear videollamada');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Sidebar support button */}
      <button
        onClick={handleOpen}
        className={`w-full flex items-center gap-2 px-4 py-2.5 border rounded-xl text-sm font-medium transition-all hover:shadow-md group ${
          controlRemotoPendiente
            ? 'bg-gradient-to-r from-indigo-500 to-purple-600 text-white border-indigo-400 ring-2 ring-indigo-300 animate-pulse'
            : 'bg-indigo-50 hover:bg-indigo-100 border-indigo-200 text-indigo-700'
        }`}
        data-testid="soporte-btn"
        title={controlRemotoPendiente ? 'Soporte remoto pendiente' : 'Asistencia Tecnica'}
      >
        <i className={`fas ${controlRemotoPendiente ? 'fa-desktop' : 'fa-headset'} group-hover:scale-110 transition-transform ${controlRemotoPendiente ? 'text-white' : 'text-indigo-500'}`} />
        <span>{controlRemotoPendiente ? 'Soporte Remoto' : 'Soporte'}</span>
        {!controlRemotoPendiente && adminDisponible && (
          <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse ml-auto" />
        )}
        {controlRemotoPendiente && (
          <span className="ml-auto bg-white text-indigo-700 text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center">!</span>
        )}
      </button>

      {/* Modal */}
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="w-[calc(100vw-2rem)] max-w-md max-h-[85vh] overflow-y-auto p-0">

          {/* ============ MENU PRINCIPAL ============ */}
          {view === 'menu' && (
            <>
              <div className="bg-gradient-to-r from-indigo-500 to-purple-600 px-6 pt-6 pb-5 rounded-t-lg">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
                    <i className="fas fa-headset text-white text-lg" />
                  </div>
                  <div>
                    <h2 className="text-white font-bold text-lg leading-tight">Asistencia Tecnica</h2>
                    <p className="text-white/70 text-xs">IBA Connect - Soporte</p>
                  </div>
                </div>
                {/* Admin availability badge */}
                <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium mt-2 ${
                  adminDisponible ? 'bg-green-400/20 text-green-100' : 'bg-white/10 text-white/70'
                }`}>
                  <span className={`w-2 h-2 rounded-full ${adminDisponible ? 'bg-green-400 animate-pulse' : 'bg-white/40'}`} />
                  {adminDisponible ? 'Tecnico disponible' : 'Tecnico fuera de horario'}
                  {horarioTexto && <span className="opacity-70">· {horarioTexto}</span>}
                </div>
              </div>

              <div className="px-6 py-5 space-y-3">
                {/* Control Remoto pendiente - banner prominente */}
                {controlRemotoPendiente && (
                  <div className="bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl p-4 shadow-lg ring-4 ring-indigo-200" data-testid="control-remoto-banner">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center shrink-0">
                        <i className="fas fa-desktop text-white text-lg" />
                      </div>
                      <div className="flex-1 text-white">
                        <p className="font-bold text-sm leading-tight">🖥️ Soporte Remoto solicitado</p>
                        <p className="text-white/85 text-xs mt-1">{controlRemotoPendiente.admin_nombre} quiere ayudarte con tu PC. Tocá el botón para ver las instrucciones.</p>
                      </div>
                    </div>
                    <button
                      onClick={() => setShowTeamViewerModal(true)}
                      className="block w-full mt-3 bg-white text-indigo-700 font-bold text-center py-2.5 rounded-lg hover:bg-indigo-50 transition-colors text-sm"
                      data-testid="btn-abrir-control-remoto"
                    >
                      <i className="fas fa-info-circle mr-2" />
                      Ver Instrucciones
                    </button>
                  </div>
                )}

                {/* Mis Citas Agendadas */}
                {misCitas.length > 0 && (
                  <div className="bg-gradient-to-br from-blue-50 to-cyan-50 border-2 border-blue-200 rounded-xl p-3 space-y-2" data-testid="mis-citas-section">
                    <p className="text-xs font-semibold text-blue-700 flex items-center gap-1.5">
                      <i className="fas fa-calendar-check" />
                      Mis Citas Agendadas
                    </p>
                    {misCitas.map(c => {
                      const fechaObj = c.cita_fecha ? new Date(c.cita_fecha + 'T12:00:00') : null;
                      const fechaStr = fechaObj
                        ? fechaObj.toLocaleDateString('es-UY', { weekday: 'short', day: 'numeric', month: 'short' })
                        : c.cita_fecha;
                      return (
                        <div key={c.id} className="bg-white rounded-lg p-2.5 border border-blue-100 flex items-center gap-2" data-testid={`mi-cita-${c.id}`}>
                          <div className="w-9 h-9 bg-blue-100 rounded-lg flex items-center justify-center shrink-0">
                            <i className="fas fa-video text-blue-600 text-sm" />
                          </div>
                          <div className="flex-1 min-w-0">
                            <p className="text-xs font-semibold text-gray-800 truncate">
                              {fechaStr} - {c.cita_hora}hs
                            </p>
                            <p className="text-[10px] text-gray-500 uppercase tracking-wide">
                              {c.estado === 'abierto' ? 'Pendiente' : c.estado === 'en_progreso' ? 'En curso' : c.estado}
                            </p>
                          </div>
                          <div className="flex gap-1 shrink-0">
                            <button
                              onClick={async () => {
                                try {
                                  const API = process.env.REACT_APP_BACKEND_URL;
                                  const token = localStorage.getItem('token');
                                  const res = await fetch(`${API}/api/soporte/citas/${c.id}/renovar-sala`, {
                                    method: 'POST',
                                    headers: { Authorization: `Bearer ${token}` }
                                  });
                                  if (!res.ok) throw new Error('fail');
                                  const data = await res.json();
                                  window.open(data.url, '_blank');
                                  loadTickets();
                                } catch (_e) {
                                  alert('No se pudo renovar la sala. Intentá crear una cita nueva.');
                                }
                              }}
                              className="px-2 py-1.5 bg-amber-100 hover:bg-amber-200 text-amber-700 text-xs font-semibold rounded-lg transition-all"
                              title="Renovar sala (si expiró)"
                              data-testid={`renovar-cita-${c.id}`}
                            >
                              <i className="fas fa-sync-alt" />
                            </button>
                            <button
                              onClick={() => window.open(c.sala_url, '_blank')}
                              className="px-3 py-1.5 bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600 text-white text-xs font-semibold rounded-lg shadow-sm transition-all"
                              data-testid={`unirse-cita-${c.id}`}
                            >
                              <i className="fas fa-sign-in-alt mr-1" />Unirse
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                <p className="text-sm text-gray-500 mb-1">Como podemos ayudarte?</p>

                {/* Opción Ticket - Siempre disponible */}
                <button
                  onClick={() => setView('ticket')}
                  className="w-full flex items-center gap-4 p-4 border-2 border-gray-200 rounded-xl hover:border-indigo-300 hover:bg-indigo-50/50 transition-all group text-left"
                  data-testid="soporte-opcion-ticket"
                >
                  <div className="w-12 h-12 bg-gradient-to-br from-indigo-100 to-purple-100 rounded-xl flex items-center justify-center shrink-0 group-hover:from-indigo-200 group-hover:to-purple-200 transition-colors">
                    <i className="fas fa-ticket-alt text-indigo-600 text-xl" />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800 text-sm">Enviar un Ticket</p>
                    <p className="text-xs text-gray-500 mt-0.5">Describe tu problema y te responderemos</p>
                  </div>
                  <i className="fas fa-chevron-right text-gray-300 ml-auto" />
                </button>

                {/* Opción Citas con Soporte */}
                <button
                  onClick={() => setView('cita')}
                  className="w-full flex items-center gap-4 p-4 border-2 border-gray-200 rounded-xl hover:border-blue-300 hover:bg-blue-50/50 transition-all group text-left"
                  data-testid="soporte-opcion-cita"
                >
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-100 to-cyan-100 rounded-xl flex items-center justify-center shrink-0 group-hover:from-blue-200 group-hover:to-cyan-200 transition-colors">
                    <i className="fas fa-calendar-check text-blue-600 text-xl" />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800 text-sm">Citas con Soporte</p>
                    <p className="text-xs text-gray-500 mt-0.5">Agenda una videollamada en horario disponible</p>
                  </div>
                  <i className="fas fa-chevron-right text-gray-300 ml-auto" />
                </button>

                {/* Opción Videollamada - Solo si admin disponible */}
                {adminDisponible ? (
                  <button
                    onClick={handleIniciarVideo}
                    disabled={loading}
                    className="w-full flex items-center gap-4 p-4 border-2 border-gray-200 rounded-xl hover:border-emerald-300 hover:bg-emerald-50/50 transition-all group text-left"
                    data-testid="soporte-opcion-video"
                  >
                    <div className="w-12 h-12 bg-gradient-to-br from-emerald-100 to-teal-100 rounded-xl flex items-center justify-center shrink-0 group-hover:from-emerald-200 group-hover:to-teal-200 transition-colors">
                      {loading ? (
                        <i className="fas fa-spinner fa-spin text-emerald-600 text-xl" />
                      ) : (
                        <i className="fas fa-video text-emerald-600 text-xl" />
                      )}
                    </div>
                    <div>
                      <p className="font-semibold text-gray-800 text-sm">Videollamada de Soporte</p>
                      <p className="text-xs text-gray-500 mt-0.5">Conecta en vivo con el administrador</p>
                    </div>
                    <i className="fas fa-chevron-right text-gray-300 ml-auto" />
                  </button>
                ) : (
                  <div className="w-full flex items-center gap-4 p-4 border-2 border-dashed border-gray-200 rounded-xl opacity-60">
                    <div className="w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center shrink-0">
                      <i className="fas fa-video-slash text-gray-400 text-xl" />
                    </div>
                    <div>
                      <p className="font-semibold text-gray-500 text-sm">Videollamada no disponible</p>
                      <p className="text-xs text-gray-400 mt-0.5">
                        {horarioTexto || 'Fuera del horario de atencion'}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}

          {/* ============ FORMULARIO TICKET ============ */}
          {view === 'ticket' && (
            <>
              <div className="bg-gradient-to-r from-indigo-500 to-purple-600 px-6 pt-6 pb-5 rounded-t-lg">
                <div className="flex items-center gap-3">
                  <button onClick={() => setView('menu')} className="w-8 h-8 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center hover:bg-white/30 transition-colors">
                    <i className="fas fa-arrow-left text-white text-sm" />
                  </button>
                  <div>
                    <h2 className="text-white font-bold text-lg leading-tight">Nuevo Ticket</h2>
                    <p className="text-white/70 text-xs">Describe tu problema</p>
                  </div>
                </div>
              </div>

              <div className="px-6 py-5 space-y-5">
                {/* Categoría */}
                <div>
                  <label className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                    <i className="fas fa-tag text-indigo-500" />
                    Categoria
                  </label>
                  <div className="grid grid-cols-2 gap-2">
                    {CATEGORIAS.map(cat => (
                      <button
                        key={cat.value}
                        onClick={() => setCategoria(cat.value)}
                        className={`flex items-center gap-2 px-3 py-2.5 rounded-xl border-2 text-left text-sm transition-all ${
                          categoria === cat.value
                            ? 'border-indigo-400 bg-indigo-50 font-medium'
                            : 'border-gray-200 hover:border-gray-300'
                        }`}
                      >
                        <i className={`fas ${cat.icon} ${cat.color}`} />
                        <span className="text-gray-700 text-xs">{cat.label}</span>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Prioridad */}
                <div>
                  <label className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                    <i className="fas fa-flag text-indigo-500" />
                    Prioridad
                  </label>
                  <div className="flex gap-2">
                    {PRIORIDADES.map(p => (
                      <button
                        key={p.value}
                        onClick={() => setPrioridad(p.value)}
                        className={`flex-1 py-2 rounded-xl text-xs font-semibold transition-all border-2 ${
                          prioridad === p.value
                            ? `${p.color} border-current`
                            : 'border-gray-200 text-gray-400 hover:border-gray-300'
                        }`}
                      >
                        {p.label}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Descripción */}
                <div>
                  <label className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                    <i className="fas fa-pen text-indigo-500" />
                    Descripcion del problema
                  </label>
                  <textarea
                    value={descripcion}
                    onChange={(e) => setDescripcion(e.target.value)}
                    placeholder="Explica que problema tienes..."
                    rows={4}
                    className="w-full border-2 border-gray-200 focus:border-indigo-400 rounded-xl px-4 py-3 text-sm transition-colors outline-none resize-none"
                    data-testid="soporte-descripcion"
                  />
                </div>
              </div>

              {/* Footer */}
              <div className="px-6 pb-6 flex gap-3">
                <Button variant="outline" className="flex-1 rounded-xl h-11" onClick={() => setView('menu')}>
                  Volver
                </Button>
                <Button
                  className="flex-1 bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white rounded-xl h-11 shadow-lg shadow-indigo-200 transition-all"
                  onClick={handleEnviarTicket}
                  disabled={loading || !categoria || !descripcion.trim()}
                  data-testid="soporte-enviar-ticket"
                >
                  {loading ? (
                    <><i className="fas fa-spinner fa-spin mr-2" />Enviando...</>
                  ) : (
                    <><i className="fas fa-paper-plane mr-2" />Enviar Ticket</>
                  )}
                </Button>
              </div>
            </>
          )}

          {/* ============ VIDEOLLAMADA ============ */}
          {view === 'video' && videoUrl && (
            <>
              <div className="bg-gradient-to-r from-emerald-500 to-teal-500 px-6 pt-6 pb-5 rounded-t-lg">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
                    <i className="fas fa-video text-white text-lg" />
                  </div>
                  <div>
                    <h2 className="text-white font-bold text-lg leading-tight">Soporte Remoto</h2>
                    <p className="text-white/70 text-xs">El administrador fue notificado</p>
                  </div>
                </div>
              </div>

              <div className="px-6 py-5 space-y-4">
                <div className="bg-emerald-50 border-2 border-emerald-200 rounded-xl p-4 text-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-emerald-400 to-teal-400 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="fas fa-phone-alt text-white text-2xl animate-pulse" />
                  </div>
                  <p className="font-semibold text-emerald-800 mb-1">Sala lista</p>
                  <p className="text-xs text-emerald-600">El administrador recibio la notificacion y se unira pronto</p>
                </div>

                <Button
                  className="w-full bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:to-teal-600 text-white rounded-xl h-12 shadow-lg shadow-emerald-200 text-base font-semibold"
                  onClick={() => window.open(videoUrl, '_blank')}
                  data-testid="soporte-unirse-video"
                >
                  <i className="fas fa-video mr-2" />
                  Unirse a la Videollamada
                </Button>

                <p className="text-xs text-gray-400 text-center">
                  Se abrira en una nueva ventana. Comparte tu pantalla para que el admin pueda ayudarte.
                </p>
              </div>

              <div className="px-6 pb-6">
                <Button variant="outline" className="w-full rounded-xl h-10" onClick={() => { setIsOpen(false); resetForm(); }}>
                  Cerrar
                </Button>
              </div>
            </>
          )}

          {/* ============ CITA CON SOPORTE ============ */}
          {view === 'cita' && (
            <>
              <div className="bg-gradient-to-r from-blue-500 to-cyan-500 px-6 pt-6 pb-5 rounded-t-lg">
                <div className="flex items-center gap-3">
                  <button onClick={() => setView('menu')} className="w-8 h-8 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center hover:bg-white/30 transition-colors">
                    <i className="fas fa-arrow-left text-white text-sm" />
                  </button>
                  <div>
                    <h2 className="text-white font-bold text-lg leading-tight">Agendar Cita</h2>
                    <p className="text-white/70 text-xs">Elige fecha y hora disponible</p>
                  </div>
                </div>
              </div>

              <div className="px-6 py-5 space-y-4">
                {/* Horario disponible del admin */}
                {scheduleData && scheduleData.days && (
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                    <p className="text-xs font-semibold text-blue-700 mb-1.5">
                      <i className="fas fa-clock mr-1" />Horario de Soporte:
                    </p>
                    <div className="grid grid-cols-2 gap-1 text-xs text-blue-600">
                      {Object.entries(scheduleData.days).filter(([, v]) => v && v.enabled).map(([day, info]) => {
                        const nombres = { lun: 'Lunes', mar: 'Martes', mie: 'Miércoles', jue: 'Jueves', vie: 'Viernes', sab: 'Sábado', dom: 'Domingo' };
                        return (
                          <span key={day}>{nombres[day] || day}: {info.from}-{info.to}hs</span>
                        );
                      })}
                    </div>
                  </div>
                )}

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Fecha</label>
                  <input
                    type="date"
                    value={citaFecha}
                    min={new Date().toISOString().split('T')[0]}
                    onChange={(e) => handleFechaChange(e.target.value)}
                    className="w-full px-3 py-2 border-2 border-gray-200 rounded-xl focus:border-blue-400 focus:outline-none text-sm"
                    data-testid="cita-fecha"
                  />
                </div>

                {citaFecha && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Hora</label>
                    {horasDisponibles.length > 0 ? (
                      <div className="grid grid-cols-3 gap-2">
                        {horasDisponibles.map(h => (
                          <button
                            key={h}
                            onClick={() => setCitaHora(h)}
                            className={`px-3 py-2 text-sm rounded-lg border-2 transition-all font-medium ${
                              citaHora === h 
                                ? 'border-blue-500 bg-blue-50 text-blue-700' 
                                : 'border-gray-200 hover:border-blue-300 text-gray-600'
                            }`}
                          >
                            {h}
                          </button>
                        ))}
                      </div>
                    ) : (
                      <p className="text-sm text-red-500 bg-red-50 rounded-lg p-3">
                        <i className="fas fa-exclamation-circle mr-1" />
                        No hay horario disponible para este dia
                      </p>
                    )}
                  </div>
                )}

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Motivo de la cita</label>
                  <textarea
                    value={citaMotivo}
                    onChange={(e) => setCitaMotivo(e.target.value)}
                    rows={3}
                    placeholder="Describe brevemente el motivo..."
                    className="w-full px-3 py-2 border-2 border-gray-200 rounded-xl focus:border-blue-400 focus:outline-none text-sm resize-none"
                    data-testid="cita-motivo"
                  />
                </div>
              </div>

              <div className="px-6 pb-6">
                <Button
                  className="w-full bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600 text-white rounded-xl h-12 shadow-lg shadow-blue-200 text-base font-semibold"
                  onClick={handleCrearCita}
                  disabled={loading || !citaFecha || !citaHora || !citaMotivo.trim()}
                  data-testid="cita-agendar-btn"
                >
                  {loading ? <i className="fas fa-spinner fa-spin mr-2" /> : <i className="fas fa-calendar-check mr-2" />}
                  Agendar Cita
                </Button>
              </div>
            </>
          )}

        </DialogContent>
      </Dialog>

      {/* Modal Soporte IBA Uruguay - instrucciones TeamViewer */}
      <Dialog open={showTeamViewerModal} onOpenChange={setShowTeamViewerModal}>
        <DialogContent className="max-w-md p-0 overflow-hidden rounded-2xl" data-testid="modal-teamviewer-instrucciones">
          <div className="bg-white">
            {/* Header */}
            <div className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 p-6 text-white text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="fas fa-headset text-3xl" />
              </div>
              <h2 className="text-xl font-bold leading-tight">Soporte IBA Uruguay</h2>
              <p className="text-white/90 text-sm mt-1">{controlRemotoPendiente?.admin_nombre || 'El administrador'} quiere ayudarte con tu PC</p>
            </div>

            {/* Body */}
            <div className="p-5 space-y-4">
              <div className="text-sm text-gray-700 leading-relaxed">
                Para que podamos ayudarte de forma remota, vas a usar <b>TeamViewer</b>, una herramienta segura y confiable.
              </div>

              <div className="bg-indigo-50 border border-indigo-200 rounded-xl p-4">
                <p className="font-semibold text-indigo-900 text-sm mb-2">📋 Pasos a seguir:</p>
                <ol className="space-y-2 text-sm text-indigo-900">
                  <li className="flex gap-2">
                    <span className="bg-indigo-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold shrink-0">1</span>
                    <span>Descargá TeamViewer con el botón de abajo (lo abrís sin instalar nada)</span>
                  </li>
                  <li className="flex gap-2">
                    <span className="bg-indigo-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold shrink-0">2</span>
                    <span>Ejecutá el archivo descargado. TeamViewer te mostrará un <b>ID</b> y una <b>contraseña</b></span>
                  </li>
                  <li className="flex gap-2">
                    <span className="bg-indigo-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold shrink-0">3</span>
                    <span>Enviale ese <b>ID</b> y <b>contraseña</b> al administrador por el chat de soporte (o WhatsApp)</span>
                  </li>
                  <li className="flex gap-2">
                    <span className="bg-indigo-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold shrink-0">4</span>
                    <span>El administrador se conectará y verás cómo se mueve el mouse en tu pantalla. ¡Listo!</span>
                  </li>
                </ol>
              </div>

              {/* Botón de descarga - detecta SO */}
              {(() => {
                const so = detectarSO();
                const links = {
                  windows: { url: 'https://download.teamviewer.com/download/TeamViewerQS.exe', label: 'Descargar para Windows', icon: 'fa-windows' },
                  mac: { url: 'https://download.teamviewer.com/download/TeamViewerQS.dmg', label: 'Descargar para Mac', icon: 'fa-apple' },
                  linux: { url: 'https://www.teamviewer.com/en/download/linux/', label: 'Descargar para Linux', icon: 'fa-linux' },
                  android: { url: 'https://play.google.com/store/apps/details?id=com.teamviewer.quicksupport.market', label: 'Descargar app Android', icon: 'fa-android' },
                  ios: { url: 'https://apps.apple.com/app/id661649585', label: 'Descargar app iPhone/iPad', icon: 'fa-apple' },
                };
                const link = links[so] || links.windows;
                return (
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-bold text-center py-3 rounded-xl transition-all shadow-lg"
                    data-testid="btn-descargar-teamviewer"
                  >
                    <i className={`fab ${link.icon} mr-2 text-lg`} />
                    {link.label}
                  </a>
                );
              })()}

              <div className="flex flex-col gap-1.5 text-xs text-gray-500">
                <a href="https://www.teamviewer.com/en/download/" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:underline">
                  ¿Otro sistema operativo? Ver todas las descargas →
                </a>
              </div>

              <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-xs text-amber-900">
                <i className="fas fa-shield-alt mr-1" /> <b>Es seguro:</b> TeamViewer es usado por millones de empresas. La sesión termina cuando vos cerrás el programa.
              </div>

              <Button variant="outline" className="w-full rounded-xl h-10" onClick={() => setShowTeamViewerModal(false)} data-testid="btn-cerrar-teamviewer">
                Cerrar
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SoporteButton;
